module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.application && _vm.application.id) ? _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Your application has been successfully submitted.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.application.lodgement_number))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)))])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])]) : _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Proxy application has been successfully submitted.")]), _vm._v(" "), _c('br'), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Application: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Date:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab3debe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/application_submit.vue
// module id = 1038
// module chunks = 0